// EpcDashboard.js
import React, { useEffect, useState } from "react";
import img from "../../../assets/images/InceptionFinicallyLogo.png";
import { colors } from "../../../utils/theme";
import styles from "./index.module.css";
import { useDispatch } from "react-redux";
import { nextStep, setStep } from "../../../store/reducers/epcReducer";
import { RootState, useAppSelector } from "../../../store/store";
import EpcTable from "./EpcTable";
import { resetEpcUser } from "../../../store/reducers/epcUserReducer";
import { useGetGemsDashboardDataQuery } from "../../../services/epcApi";

// Sample data

const columns = [
  { Header: "FIRST NAME" },
  { Header: "LAST NAME" },
  { Header: "EMAIL" },
  { Header: "STREET ADDRESS" },
  { Header: "CREDIT" },
  { Header: "STATUS" },
  { Header: "LAST UPDATED" },
  { Header: "ACTION" },
];

const EpcDashboard = () => {
  const {
    epc: { step },
  } = useAppSelector((state: RootState) => state);

  const epcDetails = useAppSelector((state: RootState) => state.epcUser);
  const epcFirstName = epcDetails.firstName;
  const epcLastName = epcDetails.lastName;
  const epcCrmId = epcDetails.crmContactId;

  const [tableData, setTableData] = useState([]);
  const [popup, setPopup] = useState(false);
  const {
    data: dashboardData,
    refetch,
    isLoading,
  } = useGetGemsDashboardDataQuery();

  const dispatch = useDispatch();

  const handleLogOut = () => {
    dispatch(setStep(0));
    localStorage.removeItem("epcUser");
    dispatch(resetEpcUser());
  };

  // const getContacts = async () => {
  //   try {
  //     setIsLoading(true);
  //     const result: any = await getDashboardData(epcCrmId);

  //     if (result?.data.data.status == 200) {
  //       setTableData(result.data.data.response);
  //     }
  //   } catch (error) {
  //     console.error("Login error:", error);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  useEffect(() => {
    step == 0 && refetch();
  }, [step]);

  useEffect(() => {
    if (dashboardData?.data?.response?.length > 0) {
      setTableData(dashboardData?.data.response);
    }
  }, [dashboardData]);

  useEffect(() => {
    if (!popup) {
      refetch();
    }
  }, [popup]);

  return (
    <div className={styles.customClass}>
      <div className={styles.content}>
        <div className="w-full flex h-auto items-center justify-center">
          <div className="w-[97vw] md:w-[80vw] h-[90vh] flex flex-col items-start justify-start  ">
            <div
              className={`h-[15%] pb-6 w-full flex items-center border-[${colors.green}] border-b-2`}
            >
              {/* <div className="flex w-[30%] justify-center"> */}
              <img src={img} alt="" className="w-28 md:w-52" />
              {/* </div> */}
              <div className="flex w-[70%] flex-col flex-1 ">
                <div
                  className={`flex w-full sm:flex-row flex-col items-end justify-end  text-[${colors.green}] font-semibold my-2 `}
                >
                  <p className={`text-[${colors.green}] `}>
                    Welcome{" "}
                    <span className="underline">
                      {epcFirstName + " " + epcLastName}
                    </span>
                    <span className="mx-2 hidden sm:inline">|</span>{" "}
                  </p>
                  <button className="underline" onClick={handleLogOut}>
                    Logout
                  </button>
                </div>
                {/* {step === 0 && (
                  <div className="flex gap-8  justify-end">
                    <div className=" w-1/5 items-center justify-normal flex">
                      <CustomButton
                        buttonLabel="get ppa rate"
                        onClick={() => {
                          goToNext();
                        }}
                      />
                    </div>
                    <div className=" w-1/5 items-center justify-normal flex">
                      <CustomButton buttonLabel="pipeline" />
                    </div>
                    <div className=" w-1/5 items-center justify-normal flex">
                      <CustomButton buttonLabel="credit" />
                    </div>
                  </div>
                )} */}
              </div>
            </div>
            {step == 0 && !isLoading && (
              <div style={{ width: "100%", height: "auto" }}>
                <div
                  style={{
                    display: "flex",
                    flex: "1",
                    width: "100%",
                    height: "75vh",
                    overflowY: "auto",
                  }}
                >
                  <div className="w-full h-auto overflow-x-auto">
                    <EpcTable columns={columns} data={tableData} />
                  </div>
                </div>
              </div>
            )}
            {step == 0 && isLoading && (
              <div className="absolute inset-0 flex items-center justify-center">
                <svg
                  aria-hidden="true"
                  className="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#50b56e]"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
              </div>
            )}
            {/* <div className="h-[85%] w-full ">
              <PpaCalculator />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EpcDashboard;
